 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		106: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		106: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"13":"ExamBoostAnimation","14":"NoWrongAnswersAnimation","15":"quiz-animation","16":"transfer-subscription-no-children-animation","24":"ChatbotQuitAnimation","25":"ChatbotTypingAnimation","26":"ExamQuestionsUpgradeAnimation","27":"FloralRewardAnimation","28":"SenecaPremiumCardAnimation","29":"accept-challenge-animation","30":"adam-image","31":"all-child-assignments","32":"anonymous-course-discovery-chunk","33":"anonymous-resources-hub","34":"anonymous-resources-hub-chunk","35":"anonymous-what-is-premium-parent","36":"anonymous-what-is-premium-teacher","37":"assignment-share-animation","38":"ben-image","39":"calendar-image","40":"car-animation","41":"child-connected-modal","42":"child-connection-invite-journey","43":"child-not-found-route","44":"child-single-assignment","45":"child-sub-router","46":"circle-books-animation","47":"claim-tutoring-journey","48":"class-page-router","49":"classes-page","50":"classroom-chunk","51":"clock-animation","52":"confetti-animation","53":"correct-answer-animation","54":"courses-page","55":"courses-page-chunk","56":"creation-chunk","57":"cute-whale-animation","58":"dark-mode-toggle-animation","59":"dashboard-router-chunk","60":"date-fns-de","61":"date-fns-de-AT","62":"date-fns-en-AU","63":"date-fns-en-GB","64":"date-fns-en-IN","65":"date-fns-en-US","66":"date-fns-es","67":"date-fns-fr","68":"date-fns-pt-BR","69":"date-fns-vi","70":"dev-tools","71":"empty-desk-animation","72":"exam-prep-topics-animation","73":"feedback-success-animation","74":"front-door-chunk","75":"get-premium-chunk","76":"gostudent-logo-animation","77":"invite-all-school-parents","78":"invite-classes-parents-animation","79":"jane-image","80":"join-group-animation","81":"link-animation","82":"loading-blocks-animation","83":"magnifying-glass-animation","85":"medal-animation","86":"mia-image","87":"mobile-auth","88":"more-sub-router","89":"mumsnet-image","90":"new-courses-chunk","91":"no-assignments-animation","92":"no-classes-animation","93":"no-course-info-animation","94":"no-study-time-animation","95":"noStudentsAssignmentsAnimation","96":"parent-dashboard","97":"parent-tutoring-page","98":"parent-what-is-premium-page","99":"parents-invite-route","100":"personalised-suggestions-courses-chunk","101":"plug-in-failed-animation","102":"plurall-help-centre-modal-chunk","103":"podium-animation","104":"progress-page","105":"receive-gift-open-animation","107":"sad-look-animation","108":"section-preview","109":"session","110":"settings-page","111":"share-animation","112":"sign-up-invite-chunk","113":"sleepy-animation","114":"smiling-with-hearts-animation","115":"speedyMarkingQuitAnimation","116":"speedyMarkingSuccessAnimation","117":"success-animation","118":"sync-classes-animation","119":"target-animation","120":"teacher-dashboard","121":"topic-score-animation","122":"transfer-subscription-error-animation","123":"transfer-subscription-success-animation","124":"trash-animation","125":"trophy-animation","126":"trustpilot-image","127":"try-a-module","128":"tutoring-activation-journey","129":"weekly-reports-page","130":"what-is-premium-chunk"}[chunkId]||chunkId) + "." + {"0":"004e77ff","1":"cc58283c","2":"dede65bb","3":"66b64c0a","4":"33cc60b8","5":"fc86092e","6":"6dff46d5","7":"0470f915","8":"154088c9","9":"1668491d","10":"38c441e9","11":"3efb2b8d","12":"799da7b7","13":"e9df791c","14":"654cd503","15":"f5bd6a0b","16":"c1042a29","17":"5570d6c6","18":"ce43c694","19":"dab67fff","20":"83311b3f","21":"f2184d83","22":"08806d5b","23":"5613cd70","24":"61e00322","25":"4383abf2","26":"f56a28b0","27":"91ad3bbd","28":"6726ce07","29":"c2274144","30":"4252b7e4","31":"cd816944","32":"c68e9173","33":"f3575de6","34":"03379a84","35":"a702eeae","36":"7b301605","37":"14a2db56","38":"79cfbf27","39":"71c373f6","40":"64027f31","41":"67cc6adf","42":"951001e1","43":"dde80cba","44":"1391c12f","45":"05110831","46":"93a68f7e","47":"1a337e74","48":"025cd3fd","49":"afaea1d3","50":"bb3bb9de","51":"3302417e","52":"d2697f7e","53":"f345ac9d","54":"1eb7acfb","55":"0b4d0cf6","56":"1a474c66","57":"76cf7ae4","58":"203efe88","59":"9f1d0fd2","60":"f77afd50","61":"9c868e8d","62":"62ffd261","63":"fc08f22f","64":"b235c16b","65":"5b386f2b","66":"549aa509","67":"df037fdb","68":"f2483e3f","69":"21b2362a","70":"517ea95c","71":"78a3acdb","72":"813f7851","73":"2f592f38","74":"509d9bc4","75":"af5870a7","76":"24a84336","77":"0f8b0f8c","78":"cfdb31a4","79":"548d10c6","80":"5df1ea7a","81":"5bd21c98","82":"587bec8d","83":"6ea09c29","85":"d65bef92","86":"73da6f34","87":"09e9f1d8","88":"6f2fd281","89":"45cd5e23","90":"f37f2ac3","91":"f503a807","92":"e810c30e","93":"54258b3c","94":"81e1d9a6","95":"518dbf70","96":"3c47eef0","97":"f5b42e6d","98":"c8af5939","99":"3a99b231","100":"6fc6ebaa","101":"463eea43","102":"774c8d0c","103":"7c4fb59c","104":"98348c9b","105":"dd77492e","107":"545357a4","108":"4f002ec8","109":"d7c6e381","110":"c6bbe595","111":"ba0cf410","112":"dcd62b32","113":"5553e875","114":"23e1f751","115":"8de5ddab","116":"f674e197","117":"09644e77","118":"44c59fa1","119":"570588e5","120":"a91a6510","121":"48d558f4","122":"17024bf4","123":"c57d2264","124":"be184b7f","125":"0960e838","126":"7575e895","127":"125e286b","128":"4294c54f","129":"ed54edec","130":"b0ed46e7","132":"c502f80c","133":"a23d61f3","134":"57010669","135":"652dbe28","136":"718a1f5e","137":"9476e37d","138":"4cf676b8"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1,"8":1,"9":1,"17":1,"19":1,"20":1,"32":1,"33":1,"34":1,"35":1,"36":1,"44":1,"48":1,"49":1,"50":1,"55":1,"56":1,"59":1,"70":1,"74":1,"75":1,"87":1,"96":1,"98":1,"104":1,"108":1,"109":1,"110":1,"112":1,"120":1,"121":1,"127":1,"129":1,"130":1,"132":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"13":"ExamBoostAnimation","14":"NoWrongAnswersAnimation","15":"quiz-animation","16":"transfer-subscription-no-children-animation","24":"ChatbotQuitAnimation","25":"ChatbotTypingAnimation","26":"ExamQuestionsUpgradeAnimation","27":"FloralRewardAnimation","28":"SenecaPremiumCardAnimation","29":"accept-challenge-animation","30":"adam-image","31":"all-child-assignments","32":"anonymous-course-discovery-chunk","33":"anonymous-resources-hub","34":"anonymous-resources-hub-chunk","35":"anonymous-what-is-premium-parent","36":"anonymous-what-is-premium-teacher","37":"assignment-share-animation","38":"ben-image","39":"calendar-image","40":"car-animation","41":"child-connected-modal","42":"child-connection-invite-journey","43":"child-not-found-route","44":"child-single-assignment","45":"child-sub-router","46":"circle-books-animation","47":"claim-tutoring-journey","48":"class-page-router","49":"classes-page","50":"classroom-chunk","51":"clock-animation","52":"confetti-animation","53":"correct-answer-animation","54":"courses-page","55":"courses-page-chunk","56":"creation-chunk","57":"cute-whale-animation","58":"dark-mode-toggle-animation","59":"dashboard-router-chunk","60":"date-fns-de","61":"date-fns-de-AT","62":"date-fns-en-AU","63":"date-fns-en-GB","64":"date-fns-en-IN","65":"date-fns-en-US","66":"date-fns-es","67":"date-fns-fr","68":"date-fns-pt-BR","69":"date-fns-vi","70":"dev-tools","71":"empty-desk-animation","72":"exam-prep-topics-animation","73":"feedback-success-animation","74":"front-door-chunk","75":"get-premium-chunk","76":"gostudent-logo-animation","77":"invite-all-school-parents","78":"invite-classes-parents-animation","79":"jane-image","80":"join-group-animation","81":"link-animation","82":"loading-blocks-animation","83":"magnifying-glass-animation","85":"medal-animation","86":"mia-image","87":"mobile-auth","88":"more-sub-router","89":"mumsnet-image","90":"new-courses-chunk","91":"no-assignments-animation","92":"no-classes-animation","93":"no-course-info-animation","94":"no-study-time-animation","95":"noStudentsAssignmentsAnimation","96":"parent-dashboard","97":"parent-tutoring-page","98":"parent-what-is-premium-page","99":"parents-invite-route","100":"personalised-suggestions-courses-chunk","101":"plug-in-failed-animation","102":"plurall-help-centre-modal-chunk","103":"podium-animation","104":"progress-page","105":"receive-gift-open-animation","107":"sad-look-animation","108":"section-preview","109":"session","110":"settings-page","111":"share-animation","112":"sign-up-invite-chunk","113":"sleepy-animation","114":"smiling-with-hearts-animation","115":"speedyMarkingQuitAnimation","116":"speedyMarkingSuccessAnimation","117":"success-animation","118":"sync-classes-animation","119":"target-animation","120":"teacher-dashboard","121":"topic-score-animation","122":"transfer-subscription-error-animation","123":"transfer-subscription-success-animation","124":"trash-animation","125":"trophy-animation","126":"trustpilot-image","127":"try-a-module","128":"tutoring-activation-journey","129":"weekly-reports-page","130":"what-is-premium-chunk"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"ac707bea","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"37c4a789","9":"20602ede","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"ca93876c","18":"31d6cfe0","19":"1f6cd108","20":"7b591213","21":"31d6cfe0","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"423c6495","33":"50fda5f8","34":"80aa8eb9","35":"38956ee4","36":"ae252323","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"55915aa3","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"f634c69f","49":"56a4722c","50":"8ac4948c","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"5bbde991","56":"4c9808af","57":"31d6cfe0","58":"31d6cfe0","59":"db66d455","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"04824323","71":"31d6cfe0","72":"31d6cfe0","73":"31d6cfe0","74":"6811b781","75":"ff5c18a4","76":"31d6cfe0","77":"31d6cfe0","78":"31d6cfe0","79":"31d6cfe0","80":"31d6cfe0","81":"31d6cfe0","82":"31d6cfe0","83":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","87":"7628eb65","88":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0","91":"31d6cfe0","92":"31d6cfe0","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"d9db2f10","97":"31d6cfe0","98":"f00bebf1","99":"31d6cfe0","100":"31d6cfe0","101":"31d6cfe0","102":"31d6cfe0","103":"31d6cfe0","104":"c677ccf4","105":"31d6cfe0","107":"31d6cfe0","108":"9b12bf8d","109":"5411c22c","110":"f969e5f7","111":"31d6cfe0","112":"6811b781","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"23924304","121":"80729292","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"31d6cfe0","126":"31d6cfe0","127":"272930af","128":"31d6cfe0","129":"24c2d648","130":"15cf7216","132":"5d9248fe","133":"31d6cfe0","134":"31d6cfe0","135":"31d6cfe0","136":"31d6cfe0","137":"31d6cfe0","138":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpseneca-web"] = this["webpackJsonpseneca-web"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
